// extracted by mini-css-extract-plugin
export default {"StartArrow":"StartArrow_StartArrow__+DUzz","Border":"StartArrow_Border__2ChQ8","pulse":"StartArrow_pulse__tI67R"};